// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid{margin:0 0 0 0;box-sizing:border-box}.grid *{box-sizing:border-box}.grid:after{content:\"\";display:table;clear:both}.grid [class*=col-]{float:left;padding:0 .5rem}.grid [class*=col-]:first-of-type{padding-left:0}.grid [class*=col-]:last-of-type{padding-right:0}.col-2-3{width:66.66%}.col-1-3{width:33.33%}.col-1-2{width:50%}.col-1-4{width:25%}.col-1-8{width:12.5%}", ""]);
// Exports
module.exports = exports;
